import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/daf7ia9tto0ceqqnh73g";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢订阅，最新一期早报已送进你的邮箱。");
      form.reset();
      setEmail("");
      setName("");
      return;
    }

    const payload = new URLSearchParams();
    const emailVal = String(formData.get("email") || "").trim();
    const nameVal = String(formData.get("name") || "").trim();
    if (emailVal) payload.set("email", emailVal);
    if (nameVal) payload.set("name", nameVal);

    setStatus("loading");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && code === "OK") {
        setStatus("success");
        setMessage("订阅成功！新一期的「吃瓜早报」会准时到你邮箱。");
        form.reset();
        setEmail("");
        setName("");
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络出了点状况，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20 px-4 pb-2 pt-4 md:px-6">
      <div className="mx-auto max-w-[1360px] overflow-hidden rounded-2xl border border-ink-800/10 bg-paper-100/80">
        <div className="grid items-stretch lg:grid-cols-2">
          <div className="relative flex flex-col justify-center p-7 md:p-10">
            <span className="inline-flex w-max items-center gap-2 rounded-full border border-melon-300 bg-melon-100 px-3 py-1.5 text-xs font-semibold text-melon-700">
              <i className="ri-mail-send-line" />
              每周二 / 周五 · 早上 8 点
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-ink-950 md:text-3xl">
              订阅「吃瓜早报」<br />
              别错过任何一条值得追的瓜
            </h2>
            <p className="mt-3 max-w-md text-sm leading-7 text-ink-500">
              每周两期：一期盘点本周值得深扒的事件与线索，一期教你一条用得上的推理工法。不刷屏、不搬运，只发我们自己拆过的东西。
            </p>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-ink-600">
              {["全程免费，随时可退订", "每期附可直接照做的拆解清单", "只发原创，绝不复制粘贴八卦号搬运稿"].map(
                (li) => (
                  <li key={li} className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-melon-600" />
                    {li}
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="flex items-center bg-sign-500 p-7 md:p-10">
            <form
              id="subscribe-form"
              data-readdy-form="daf7ia9tto0ceqqnh73g"
              onSubmit={handleSubmit}
              method="post"
              action={FORM_URL}
              className="w-full"
            >
              <label className="block text-sm font-semibold text-paper-50">怎么称呼你（选填）</label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="你的昵称"
                maxLength={20}
                className="mt-2 w-full rounded-md border border-paper-50/30 bg-paper-50 px-4 py-3 text-sm text-ink-800 placeholder-ink-400 focus:border-paper-50 focus:outline-none"
              />
              <label className="mt-4 block text-sm font-semibold text-paper-50">接收邮箱</label>
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                autoComplete="email"
                className="mt-2 w-full rounded-md border border-paper-50/30 bg-paper-50 px-4 py-3 text-sm text-ink-800 placeholder-ink-400 focus:border-paper-50 focus:outline-none"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="field-hp"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-ink-900 px-6 py-3.5 text-sm font-bold text-paper-50 transition-colors hover:bg-ink-950 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin" /> 正在订阅…
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill" /> 订阅吃瓜早报
                  </>
                )}
              </button>
              {status === "success" && (
                <p className="mt-3 flex items-start gap-2 rounded-md bg-paper-50/15 p-3 text-sm text-paper-50 animate-rise">
                  <i className="ri-checkbox-circle-line mt-0.5" />
                  {message}
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 flex items-start gap-2 rounded-md bg-sign-800/30 p-3 text-sm text-paper-50 animate-rise">
                  <i className="ri-error-warning-line mt-0.5" />
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}